// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class FloorLabelsDataMessage implements flatbuffers.IUnpackableObject<FloorLabelsDataMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):FloorLabelsDataMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsFloorLabelsDataMessage(bb:flatbuffers.ByteBuffer, obj?:FloorLabelsDataMessage):FloorLabelsDataMessage {
  return (obj || new FloorLabelsDataMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsFloorLabelsDataMessage(bb:flatbuffers.ByteBuffer, obj?:FloorLabelsDataMessage):FloorLabelsDataMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new FloorLabelsDataMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

floorLabelData():string
floorLabelData(optionalEncoding:flatbuffers.Encoding):string|Uint8Array
floorLabelData(optionalEncoding?:any):string|Uint8Array {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
}

static startFloorLabelsDataMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addFloorLabelData(builder:flatbuffers.Builder, floorLabelDataOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, floorLabelDataOffset, 0);
}

static endFloorLabelsDataMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 4) // floor_label_data
  return offset;
}

static createFloorLabelsDataMessage(builder:flatbuffers.Builder, floorLabelDataOffset:flatbuffers.Offset):flatbuffers.Offset {
  FloorLabelsDataMessage.startFloorLabelsDataMessage(builder);
  FloorLabelsDataMessage.addFloorLabelData(builder, floorLabelDataOffset);
  return FloorLabelsDataMessage.endFloorLabelsDataMessage(builder);
}

unpack(): FloorLabelsDataMessageT {
  return new FloorLabelsDataMessageT(
    this.floorLabelData()
  );
}


unpackTo(_o: FloorLabelsDataMessageT): void {
  _o.floorLabelData = this.floorLabelData();
}



unpackFields(...fields: string[]): FloorLabelsDataMessageT {
  const t = new FloorLabelsDataMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('floor_label_data')) {
    t.floorLabelData = this.floorLabelData();
  }
  return t;
}
}

export class FloorLabelsDataMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public floorLabelData: string|Uint8Array|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  if (this.floorLabelData === null || this.floorLabelData === undefined) {
    throw new Error('Required field "floor_label_data" is not set');
  }
  const floorLabelData = (this.floorLabelData !== null ? builder.createString(this.floorLabelData!) : 0);

  return FloorLabelsDataMessage.createFloorLabelsDataMessage(builder,
    floorLabelData
  );
}

clone(): FloorLabelsDataMessageT {
  const obj = new FloorLabelsDataMessageT();
  obj.floorLabelData = this.floorLabelData;
  return obj;
}

equals(other: FloorLabelsDataMessageT): boolean {
  if (this.floorLabelData !== other.floorLabelData) return false;
  return true;
}
}

export function verifyFloorLabelsDataMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, 'floor_label_data');
  } finally {
    verifier.popDepth();
  }
}
